import { render } from "./Table-row-upload-document.vue?vue&type=template&id=18f3f4a2"
import script from "./Table-row-upload-document.vue?vue&type=script&lang=ts"
export * from "./Table-row-upload-document.vue?vue&type=script&lang=ts"
script.render = render

export default script